export default function Title({title}){
    return <h1> {title} </h1>
}